
import { defineComponent, SetupContext, ref, computed, onMounted, nextTick } from "vue";
import NativeClient from "@/client/native-client";
import PantryRadioItem from "./PantryRadioItem.vue";
import { PantryDetailInfo, PANTRY_STRING, PLATE_STOCK_NOTIFICATION_TYPE, PLATE_DISPLAY_FORMAT, NETWORK_TIMING, RegisterPantryPlatePlateInfo, DETAIL_ITEM_TITLE } from "@/types/pantry";

export default defineComponent({
  name: "PantryStockNotificationValueDialog",
  components: {
    PantryRadioItem
  },
  props: {
    maxStockValue: {
      type: Number,
      default: 20,
      require: true
    },
    data: {
      type: RegisterPantryPlatePlateInfo,
      default: null,
      require: true
    },
    displayFormat: {
      type: Number,
      default: PLATE_DISPLAY_FORMAT.GAUGE,
      require: true
    },
    networkTiming: {
      type: Number,
      default: NETWORK_TIMING.NORMAL,
      require: true
    },
    time: {
      type: String,
      default: "0:00",
      require: true
    },
    stock: {
      type: String,
      default: "",
      require: true
    }
  },
  setup(props, context: SetupContext) {
    const selectId = ref(PLATE_STOCK_NOTIFICATION_TYPE.NONE);
    const timeList = ref(Array<string>());
    const gaugeList = ref(Array<string>());
    const valueList = ref(Array<string>());
    const valueTime = ref("");
    const valueStock = ref(props.stock);
    const init = () => {
      for (let i = 0; i < 24; i++) {
        const item = "" + i + ":00";
        timeList.value.push(item);
      }
      for (let i = 0; i <= 100; i+=10) {
        const item = "" + i + "%";
        gaugeList.value.push(item);
      }
    };
    init();
    const onClickSetting = () => {
      NativeClient.sendDebugLog("PantryStockNotificationValueDialog onClickSetting selectId=" + selectId.value);
      NativeClient.sendDebugLog("PantryStockNotificationValueDialog onClickSetting valueTime=" + valueTime.value);
      NativeClient.sendDebugLog("PantryStockNotificationValueDialog onClickSetting valueStock=" + valueStock.value);
      let stock = -1;
      let time = null;
      let array = gaugeList.value;
      if (props.displayFormat == PLATE_DISPLAY_FORMAT.VALUE) {
        array = valueList.value;
      }
      let i = 0;
      array.forEach(item => {
        if (item == valueStock.value) {
          stock = i;
          if (props.displayFormat == PLATE_DISPLAY_FORMAT.GAUGE) {
            stock *= 10;
          }
          return;
        }
        i++;
      });
      i = -1;
      timeList.value.forEach(item => {
        if (item == valueTime.value) {
          time = i + 1;
          return;
        }
        i++;
      });
      NativeClient.sendDebugLog("PantryStockNotificationValueDialog onClickSetting time=" + time);
      NativeClient.sendDebugLog("PantryStockNotificationValueDialog onClickSetting stock=" + stock);
      context.emit("click-setting", selectId.value, time, stock);
    };
    const onClickClose = () => {
      context.emit("click-close");
    };
    const getRadioIcon = (check: boolean) => {
      return (check) ? require("@/assets/images/radio_on.png") : require("@/assets/images/radio_off.png");
    };
    const getRadioImage = (id: number) => {
      return getRadioIcon(selectId.value == id);
    };
    const selectChecked = (id: number) => {
      selectId.value = id;
    };
    const getLowValueList = () => {
      let list = Array<string>();
      if (props.displayFormat == PLATE_DISPLAY_FORMAT.GAUGE) {
        list = gaugeList.value;
      } else {
        list = valueList.value;
      }
      return list;
    };

    const updateData = computed(() => {
      NativeClient.sendDebugLog("PantryStockNotificationValueDialog updateData date=" + JSON.stringify(props.data));
      selectId.value = PLATE_STOCK_NOTIFICATION_TYPE.NONE;
      if (props.data != null && props.data.remaining) {
        selectId.value = props.data.remaining.timing;
        valueList.value.length = 0;
        for (let i = 0; i <= props.maxStockValue; i++) {
          const item = "" + i + "個";
          valueList.value.push(item);
        }
      }
    });
    const getStockChangeText = () => {
      let result = "残量が変化するたび";
      if (props.networkTiming == NETWORK_TIMING.ENERGY_SAVING) {
        result = "残量が変化した日だけ";
      }
      return result;
    };
    const getStockLowText = () => {
      let result = "残量が少ない時だけ";
      if (props.networkTiming == NETWORK_TIMING.ENERGY_SAVING) {
        result = "残量が少ない日だけ";
      }
      return result;
    };
    const getEveryDayText = () => {
      let result = "1日に1回だけ";
      if (props.networkTiming == NETWORK_TIMING.ENERGY_SAVING) {
        result = "毎日お知らせ";
      }
      return result;
    };
    const updateTime = computed(() => {
      NativeClient.sendDebugLog("PantryStockNotificationValueDialog updateTime time=" + JSON.stringify(props.time));
      valueTime.value = props.time;
    });
    const updateStock = computed(() => {
      NativeClient.sendDebugLog("PantryStockNotificationValueDialog updateStock time=" + JSON.stringify(props.stock));
      valueStock.value = props.stock;
    });
    return {
      selectId,
      getRadioImage,
      onClickSetting,
      onClickClose,
      selectChecked,
      getLowValueList,
      getEveryDayText,
      getStockChangeText,
      getStockLowText,
      timeList,
      updateData,
      valueTime,
      valueStock,
      PANTRY_STRING,
      PLATE_STOCK_NOTIFICATION_TYPE,
      NETWORK_TIMING,
      updateTime,
      updateStock,
      DETAIL_ITEM_TITLE
    }
  }
});
